"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const octopod_auth_1 = require("@produits-internes-oss/octopod-auth");
const react_1 = require("react");
const useRouter_1 = require("./contexts/useRouter/useRouter");
const useStore_1 = require("./contexts/useStore/useStore");
const useServiceWorker_1 = require("./hooks/useServiceWorker/useServiceWorker");
const Unauthorized_1 = require("./screens/Unauthorized/Unauthorized");
const Header_1 = require("./components/Header/Header");
const Loader_1 = require("./components/Loader/Loader");
const app_styled_1 = require("./app.styled");
const App = () => {
    const { connection } = (0, octopod_auth_1.useAuthenticator)();
    const { renderer } = (0, useRouter_1.useRouter)();
    const { hasPrefetched } = (0, useStore_1.useStore)();
    const { register } = (0, useServiceWorker_1.useServiceWorker)({ enable: false });
    (0, react_1.useEffect)(() => { register('worker.js'); }, [register]);
    if (connection.status === 'pending')
        return null;
    if (connection.status === 'unauthorized' || connection.status === 'stale')
        return (0, jsx_runtime_1.jsx)(Unauthorized_1.Unauthorized, {});
    return ((0, jsx_runtime_1.jsx)(app_styled_1.AppStyled, { children: !hasPrefetched ? (0, jsx_runtime_1.jsx)(Loader_1.Loader, {}) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, {}), (0, jsx_runtime_1.jsx)("section", { children: renderer })] })) }));
};
exports.App = App;
//# sourceMappingURL=app.js.map